<template>
  <div id="app">
    <el-container>
      <el-header
        v-if="
          path != '/leaderspeech' &&
          path != '/area' &&
          path != '/events' &&
          path != '/contact' &&
          path != '/five' &&
          path != '/memo' &&
          path != '/productservice'&&
          path != '/error_404'
        "
      >
        <SzyHeader></SzyHeader>
      </el-header>
      <el-main>
        <keep-alive :include="includeList">
          <router-view></router-view>
        </keep-alive>
        <!-- <div class="affix" @click="openForm('form')" v-if="
          path != '/leaderspeech' &&
          path != '/area' &&
          path != '/events' &&
          path != '/contact' &&
          path != '/five' &&
          path != '/memo' &&
          path != '/productservice'
        "> 
          <div class="user"><i class="el-icon-user"></i></div>
          <div class="demand">您的需求</div>
        </div> -->
        <!-- <div class="affix" @click="openForm('form')" :class="isMobile?'isMobile':''" v-if="!isMobile"> 
          <div class="user"><i class="el-icon-user"></i></div>
          <div class="demand">您的需求</div>
        </div> -->
        <!-- <div class="affix_isMobile" @click="openForm('form')" v-else>
          <div class="user"><i class="el-icon-phone-outline"></i></div>
        </div> -->
        <el-dialog title="您的需求" :visible.sync="businessVisible" :width="isMobile?'90%':'26%'" :custom-class="isMobile?'mobileClass':''">
          <el-form :model="form" label-width="80px" :rules="rules" ref="form">
            <el-form-item label="姓名" prop="name">
              <el-input
                v-model="form.name"
                autocomplete="off"
                placeholder="请输入您的姓名"
              ></el-input>
            </el-form-item>

            <el-form-item label="联系方式" prop="mobile">
              <el-input
                v-model="form.mobile"
                autocomplete="off"
                placeholder="请输入联系方式"
              ></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input
                v-model="form.email"
                autocomplete="off"
                placeholder="请输入电子邮箱"
              ></el-input>
            </el-form-item>
            <el-form-item label="客户类型" prop="type">
              <el-select v-model="form.type" placeholder="请选择客户类型">
               
                <el-option label="政府" value="2"></el-option>
                <el-option label="企业" value="1"></el-option>
                <el-option label="个人" value="3"></el-option>

              </el-select>
            </el-form-item>

            <el-form-item
              label="企业名称"
              prop="enterpriseName"
              v-if="form.type != '3'"
            >
              <el-input
                v-model="form.enterpriseName"
                autocomplete="off"
                placeholder="请输入企业名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="您的需求" prop="demand">
              <el-input
                v-model="form.demand"
                autocomplete="off"
                type="textarea"
                placeholder="请输入您的需求"
              ></el-input>
            </el-form-item>
            <el-form-item class="form_btn">
              <el-button @click="onSubmit('form')" round>立即提交</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </el-main>
      <el-footer
        v-if="
          path != '/leaderspeech' &&
          path != '/area' &&
          path != '/events' &&
          path != '/contact' &&
          path != '/five' &&
          path != '/memo' &&
          path != '/productservice'&&
          path != '/error_404'
        "
      >
        <SzyFooter></SzyFooter>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import SzyHeader from "./components/Header/Header.vue";
import SzyFooter from "@/components/Footer/Footer.vue";
import homePage from "@/core/models/homePage";

export default {
  name: "app",
  components: {
    SzyHeader,
    SzyFooter,
  },
  data() {
    return {
      path: "/",
      businessVisible: false,
      isMobile:false,
      form: {
        name: "",
        mobile: "",
        email: "",
        type: "",
        enterpriseName: "",
        demand: "",
      },
      rules: {
        name: [{ required: true, message: "请输入您的姓名", trigger: "blur" }],
        mobile: [
          { required: true, message: "手机号码不能为空", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "请选择客户类型", trigger: "change" },
        ],
        enterpriseName: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
        demand: [
          { required: true, message: "请输入您的需求", trigger: "blur" },
        ],
      },
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.path = route.path;
        console.log(this.path);
      },
      immediate: true,
    },
    includeList(newval) {
      console.log(newval);
    },
  },
  computed: {
    includeList() {
      return this.$store.state.pageListArr;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitForm();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async submitForm() {
      const res = await homePage.submitCustomerDemand(this.form);
      if (res.code === 200) {
        this.$message({
          message: "提交成功,我们将尽快和您联系!",
          type: "success",
        });
        this.businessVisible = false;
        this.$refs.form.resetFields();
      } else {
        this.$message.error(res.msg);
      }
    },
    openForm(formName){
      this.businessVisible = true;
      this.$refs[formName].resetFields();
    },
    handleResize() {
      if (window.innerWidth <= 768) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
body {
  // background-color: rgba(247, 249, 251, 100);
  height: 100vh;
  background-color: #fff;
}
.el-header {
  height: 58px !important;
  padding: 0;
  background-color: rgba(255, 255, 255, 95);
  // min-width: 1650px;
}
.el-main {
  padding: 0;
  width: 100%;
  margin: 0 auto;
  .affix {
    position: fixed;
    right: 20px;
    bottom: 150px;
    z-index: 850;
    width: 50px;
    height: 145px;
    background: #b50000;
    border: 1px solid #b50000;
    border-radius: 36px;
    text-align: center;
    color: #fee8c4;
    cursor: pointer;
    .user {
      margin-top: 15px;
      .el-icon-user {
        font-size: 24px;
      }
    }
    .demand {
      writing-mode: vertical-lr;
      margin: 0 auto;
      font-size: 18px;
      margin-top: 10px;
    }
  }
  .affix_isMobile{
    position: fixed;
    right: 10px;
    bottom: 150px;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #b50000;
    border: 1px solid #b50000;
    text-align: center;
    color: #fee8c4;
    line-height: 30px;
  }
  .isMobile{
    width: 25px;
    height: 90px;
    border-radius: 18px;
    .user {
      margin-top: 2px;
      .el-icon-user {
        font-size: 12px;
      }
    }
    .demand {
      writing-mode: vertical-lr;
      margin: 0 auto;
      font-size: 12px;
      margin-top: 10px;
    }
  }
  :deep(.el-dialog__wrapper) {
    .el-dialog {
      .el-dialog__header {
        background-color: #b50000;
        padding: 10px 20px;
        .el-dialog__headerbtn {
          top: 13px;
          .el-dialog__close {
            color: #fee8c4;
          }
        }
        .el-dialog__title {
          color: #fee8c4;
        }
      }
      .el-dialog__body {
        padding: 30px 45px;
        background-image: url("./assets/images/fwbj.jpg");
        background-size: cover; /* 或者使用 100% 100% */
        background-position: center; /* 确保图片居中 */
        background-repeat: no-repeat; /* 防止图片重复 */
        // width: 100%; /* 确保元素宽度为100% */
        // height: 100vh; /* 确保元素高度为视口高度的100% */
        .el-form {
          .form_btn {
            .el-form-item__content {
              // text-align: center;
              .el-button {
                background-color: #b50000;
                color: #fee8c4;
                margin-left: 20%;
              }
            }
          }
        }
      }
    }
    .mobileClass{
      .el-dialog__body{
        padding: 30px 15px;
      }
    }
  }
}
.el-footer {
  padding: 0;
}
@media (max-width: 768px) {
  .el-header {
    height: 120px !important;
  }
}
</style>
